/**
 * The entrypoint for the checkout v2 shortcode.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import "./shortcode/checkoutV2/style/checkoutV2.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { Provider } from "./components/provider.js";
import { CheckoutV2Root } from "./shortcode/checkoutV2/root.js";
ready().then(()=>{
    const elements = document.querySelectorAll("div.real-commerce-checkout-v2");
    elements.forEach((item)=>{
        // Drop the PHP pre-hydration marker — its SCSS `min-height` reserves
        // space for the first paint but would clamp a tall real checkout.
        item.classList.remove("real-commerce-checkout-v2--is-pre-hydration");
        createRoot(item).render(/*#__PURE__*/ _jsx(Provider, {
            configProvider: {
                locale: {
                    locale: ""
                }
            },
            children: /*#__PURE__*/ _jsx(CheckoutV2Root, {
                ...$(item).data()
            })
        }));
    });
});
